// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".c-chat-window{display:flex;flex-direction:column;justify-content:space-between;width:100%}@media(min-width: 768px){.c-chat-window{width:100% !important}}@media(min-width: 1024px){.c-chat-window{width:calc(100% - 600px)}}@media(min-width: 1200px){.c-chat-window{width:calc(100% - 700px)}}", ""]);
// Exports
module.exports = exports;
